type Activity = {
  activity_type?: string | null;
  extra_data?: unknown;
  lead?: unknown;
};

export const isProfileInquiryAssignment = (activity: Activity) =>
  activity.activity_type === 'assignment' &&
  typeof activity.extra_data === 'object' &&
  activity.extra_data != null &&
  'profile_inquiry_origin' in activity.extra_data &&
  activity.extra_data.profile_inquiry_origin === true;
